import {useCallback} from 'react';
import {useKiosko} from '../useKiosko';
import {useKioskoStore} from '../useKioskoStore';

export const useDispenserControls = () => {
  const {sendMessage} = useKiosko();

  const {
    connection: {isConnected, error},
    apiKey,
    setPrinterState,
  } = useKioskoStore();

  const printCard = useCallback(
    (guestCardData?: {guest_name: string; room_number: string}) => {
      if (!isConnected) {
        console.warn('⚠️ Cannot print card: WebSocket not connected');
        return false;
      }

      setPrinterState({isPrinting: true});

      const cardData = guestCardData || {
        room_number: '101',
        guest_name: 'Test Guest',
      };

      return sendMessage('print_card', cardData, apiKey);
    },
    [isConnected, sendMessage, apiKey, setPrinterState],
  );

  return {
    isConnected,
    error,
    printCard,
  };
};
